import { BaseService, type ResponseMessage } from "@kiddocare-platform/portal-common/base";
import type { Announcement } from "@kiddocare-platform/portal-common/communication";

export class CommunicationBroadcastService extends BaseService {

  public async GetAnnouncements(): Promise<ResponseMessage<Array<Announcement>>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/broadcasts/getAnnouncements`);
      return response.data;
    } catch (error: any) {
      this.log.error("GetAnnouncements", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async DismissAnnouncement(idAnnouncement: bigint): Promise<ResponseMessage<unknown>> {
    try {
      const response = await this.AxiosInstance.post(`/parent/broadcasts/dismissAnnouncement/${idAnnouncement}`);
      return response.data;
    } catch (error: any) {
      this.log.error("DismissAnnouncement", error.stack, JSON.stringify(error));
      throw error;
    }
  }
}